
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/gifts",
      function () {
        return require("private-next-pages/user/gifts/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/gifts"])
      });
    }
  